const network = {
    name: 'Neutron',
    lcd_api: 'https://neutron-rest.publicnode.com',
    rpc_api: 'https://neutron-rpc.publicnode.com',
    websocket_url: 'wss://neutron-rpc.publicnode.com:443/websocket',

    denom: 'untrn',
    token_name: 'NTRN',
    chain_id: 'neutron-1',
    prefix: 'neutron',
    explorer_link: 'https://www.mintscan.io/neutron/tx/{tx_hash}',
    alias: 'neutron',
    chain_registry_alias: 'neutron',
    exponent: 6,
    gas_adjustment: 1.6,
    address_length: 20,
    gas_amount_send: 300000,
    gas_amount_claim: 300000,
    gas_amount_stake: 250000,
    gas_amount_unstake: 250000,
    gas_amount_redelegate: 300000,
    is_staking_available: false
}

export default network